export class ButtonWithText extends Phaser.GameObjects.Container {

    public label: Phaser.GameObjects.Text;
    public image: Phaser.GameObjects.Image;

    private originalScale:  number;
    private buttonImage: Phaser.GameObjects.Image;
    
    constructor(scene: Phaser.Scene, buttonImage: Phaser.GameObjects.Image, label: Phaser.GameObjects.Text, callback: Function, context: any, image?: Phaser.GameObjects.Image) {
        
        super(scene);

        this.label = label;
        this.image = image || null;
        this.buttonImage = buttonImage;

        this.buttonImage.setInteractive();

        buttonImage.on("pointerover", () => { 
            this.originalScale = this.scaleX;
            this.setScale(1.025 * this.originalScale);   
        }, this);
        
        buttonImage.on("pointerout", () => { 
            this.setScale(this.originalScale);  
        }, this);

        buttonImage.on("pointerup", () => {
            callback.apply(context);
        }, this);
        this.add(this.buttonImage);

        this.add(label);

        if (this.image) {
            this.add(this.image);
        }
    }

    public disable(): void {

        this.buttonImage.disableInteractive();
    }

    public enable(): void {

        this.buttonImage.setInteractive();
    }
}

